import {
  Atom,
  BarChart2,
  Book,
  BookOpen,
  Calculator,
  Dna,
  FlaskConical,
  Gavel,
  Globe,
  Landmark,
  Languages,
  Monitor,
  type LucideIcon,
} from "lucide-react";

const map: Record<string, LucideIcon> = {
  "Mathematics": Calculator,
  "Maths": Calculator,
  "Physics": Atom,
  "Chemistry": FlaskConical,
  "Biology": Dna,
  "Science": Atom,
  "Computer Science": Monitor,
  "Social Science - History": Landmark,
  "Social Science - Civics": Gavel,
  "Social Science - Geography": Globe,
  "Social Science - Economics": BarChart2,
  "Hindi - Vasant": Languages,
  "Hindi - Kritika": Languages,
  "Hindi": Languages,
  "English - Honeydew": BookOpen,
  "English - Beehive": BookOpen,
  "English - First Flight": BookOpen,
  "English": BookOpen,
  "Kannada": Book,
};

export function getSubjectIcon(name: string): LucideIcon {
  return map[name] ?? Book;
}
